<template>
  <p></p>
</template>

<style lang="scss" scoped>
@charset "utf-8";
@import '../../scss/variables';
</style>

<script>
// @flow
import { Auth } from 'services'
export default {
  name: 'logout',

  props: {
    error: {
      type: String,
      default: () => ''
    }
  },

  mounted() {
    if (!Auth.isUserPersistent()) {
      Auth.deleteToken()
      Auth.deleteCredentials()
      this.$router.replace({ name: 'login', params: { error: this.error } })
    }
  }
}
</script>
